import dynamic from "next/dynamic";

// Below-the-fold; lazy-load the form bundle (matches repo CWV convention).
// ContactUsForm already IS the dark "Let's simplify your chemical procurement"
// banner from the Figma (logo + heading + form + gradient) — render it directly.
const ContactUsForm = dynamic(
  () => import("@/components/us-website/ContactUsForm/ContactUsForm"),
);

/**
 * Bottom CTA banner. Delegates entirely to the shared ContactUsForm, which
 * renders the full dark gradient banner.
 *
 * Deliberately passes NO props, so every landing page shows the same banner as
 * the rest of the site (`/industry`, `/industry/[industrySlug]`,
 * `/product/[singleProduct]` all render a bare `<ContactUsForm />`):
 * "Streamline / your chemical / procurement".
 *
 * ⚠️ Do not re-add `customText`. ContactUsForm composes its heading as
 * `{headingHighlight}` / `{customText || "your chemical"}` / `procurement` — the
 * word "procurement" is already hardcoded as the third line. Passing
 * `customText: "your chemical procurement"` (as the configs used to) rendered
 * "your chemical procurement / procurement".
 *
 * `productId` is the ONE exception to the no-props rule, and it is not a
 * presentation prop: on a single-product page it attributes the enquiry to that
 * product in the payload. Omitted on the supplier types, which cover many products,
 * so their banner is unchanged.
 */
export default function CtaBanner({ productId }) {
  return <ContactUsForm product={productId} />;
}
